import { copy } from "../content/copy";

export default function Footer() {
  return (
    <footer className="footer">
      <p>{copy.footer.line}</p>
      <p className="footer-copy">{copy.footer.copyright}</p>
    </footer>
  );
}
